import React, { useContext, useState } from 'react';
import { Button, Drawer } from '@mui/material';
import { useStyles } from './DrawerSearchWidgetStyles';
import { SearchBarPopup } from '@/components/step1/search_bar/SearchBarPopup';
import { AppContext } from '@/utils/appContext';
import { ISearchForm } from '@/interfaces/bookingContext';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import 'line-awesome/dist/line-awesome/css/line-awesome.css';
import { usePostSearch } from '@/api/availability';
import {g, gEventSearchArg, website} from '@/utils/helpers';

const DrawerSearchWidget = () => {
  const appContext = useContext(AppContext);
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [drawerSearchState, setDrawerSearchState] = useState<boolean>(false);

  const showSidebar = () => {
    setDrawerSearchState(true);
    /*// Disables Background Scrolling whilst the SideDrawer/Modal is open
    if (typeof window !== "undefined" && window.document) {
      window.document.body.style.overflow = "hidden";
    }*/
  };

  const hideSidebar = () => {
    setDrawerSearchState(false);
    /*// Unsets Background Scrolling to use when SideDrawer/Modal is closed
    window.document.body.style.overflow = "unset";*/
  };

  const sumGuests = () => {
    let count = 0;
    appContext.searchForms.forEach((sF: ISearchForm) => {
      count += sF.NoOfAdults;
      count += sF.ageOfChildren.length;
    });
    return count;
  };

  const sumPets = () => {
    let count = 0;
    appContext.searchForms.forEach((sF: ISearchForm) => {
      count += sF.Pets;
    });
    return count;
  };

  const setQuantity = (category: string, isIncrement: boolean, searchFormNum: number) => {

    // appContext.resetAvailability();

    const searchForm = [...appContext.searchForms];

    if (category === 'NoOfAdults') {
      if (isIncrement) {
        searchForm[searchFormNum][category] += 1;
      } else if (!isIncrement && searchForm[searchFormNum][category] > 1) {
        searchForm[searchFormNum][category] -= 1;
      }
    } else if (category === 'Children') {
      if (isIncrement) {
        searchForm[searchFormNum].ageOfChildren.push(-1);
      } else {
        searchForm[searchFormNum].ageOfChildren.pop();
      }
    }
    // searchForm[searchFormNum].status = 'to_start';
    appContext.setSearchForms([...searchForm]);
    sumGuests();
  };


  const setPets = (isIncrement: boolean, indexForm: number) => {
    //appContext.resetAvailability();
    const searchForm = [...appContext.searchForms];
    if (isIncrement && searchForm[indexForm]['Pets'] < 2) {
      searchForm[indexForm]['Pets'] += 1;
    } else if (!isIncrement && searchForm[indexForm]['Pets'] > 0) {
      searchForm[indexForm]['Pets'] -= 1;
    }
    appContext.setSearchForms([...searchForm]);
    sumPets();
  };

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    if (
      appContext.searchForms[appContext.orderIndex].GuestArrival === null ||
      appContext.searchForms[appContext.orderIndex].GuestDeparture === null ||
      appContext.searchForms[appContext.orderIndex].GuestArrival === '' ||
      appContext.searchForms[appContext.orderIndex].GuestDeparture === ''
    ) {
      toast.warning(t('seleziona_date').toString());
    } else if (
      appContext.searchForms[appContext.orderIndex].GuestArrival === appContext.searchForms[appContext.orderIndex].GuestDeparture
    )  {
      toast.warning(t('date_arrivo_partenza_uguali').toString());
    } else if (
      appContext.searchForms[appContext.orderIndex].destination === '' &&
      appContext.searchForms[appContext.orderIndex].property === '' &&
      appContext.searchForms[appContext.orderIndex].landscape === ''
    ) {
      toast.warning(t('seleziona_destinazione').toString());
    } else if (
      appContext.searchForms[appContext.orderIndex].ageOfChildren.length > 0 &&
      appContext.searchForms[appContext.orderIndex].ageOfChildren.includes(-1)
    ) {
      toast.warning(t('selezionare_eta_dei_bambini').toString());
    } else {
      // appContext.searchForms[appContext.orderIndex].autoSearch = true;
      appContext.setSearchForms([...appContext.searchForms]);
      appContext.setBackdropIsOpen(true);
      let bookingURI = website.code === 'CE' ? window.location.origin : 'https://huopenair.com';

      if (window.location.origin.includes('//test.')) {
        bookingURI = 'https://test.huopenair.com'
      }

      if (appContext.language !== 'en') {
        bookingURI += `/${appContext.language}`;
      }

      try {
        const response = await usePostSearch(appContext.searchForms[appContext.orderIndex], appContext.userId, 'tokenRecaptcha');

        console.log(response);

        g('event', 'search_v2', gEventSearchArg(appContext.searchForms[appContext.orderIndex], appContext.userId));

        if (response.data.search_id) {
          if (appContext.searchForms[appContext.orderIndex].property) {
            appContext.setPropertySelected(appContext.searchForms[appContext.orderIndex].property);
          }
          bookingURI += `/booking-online#/search/${response.data.search_id}`;
          window.location.href = bookingURI;
        }
      } catch (e) {
        console.error(e);
      } finally {
        // appContext.setBackdropIsOpen(false);
        // setDrawerSearchState(false);
      }

    }
  };

  return (
    <>
      <Button className={classes.drawerBtn} onClick={() => showSidebar()}>{t('Prenota ora')}</Button>
      <Drawer
        anchor={'right'}
        open={drawerSearchState}
        className={classes.root}
        disableScrollLock={true}
        disablePortal={true}
        onClose={() => {hideSidebar()}}>
        <SearchBarPopup params={{ setQuantity, setPets, setDrawerSearchState, handleSubmit, hideSidebar }}
                        container={'DrawerSearchWidget'} />
      </Drawer>
    </>
  );

};

export default DrawerSearchWidget;
